/* eslint-disable */

import React, { useEffect, useState } from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { Typography, Space } from 'antd';
import { SettingOutlined } from '@ant-design/icons';

import APISettingSMS from './APISettingSMS.js';
import APISettingEmail from './APISettingEmail.js';
import APISettingDellivery from './APISettingDellivery.js';

const { Title, Text } = Typography;

function APISetting(props) {
  const location = useLocation();
  const [submenu_root, setSubmenu_root] = useState('SMS');

  useEffect(() => {
    if (location.pathname.includes('/apisetting/sms')) {
      setSubmenu_root('SMS');
    }
    if (location.pathname.includes('/apisetting/email')) {
      setSubmenu_root('Email');
    }
    if (location.pathname.includes('/apisetting/delivery')) {
      setSubmenu_root('Delivery');
    }
  }, [location]);

  return (
    <div className='page-wrapper'>
      <div className='page-header-actions' style={{ marginBottom: '24px' }}>
        <div>
          <Title level={3} style={{ margin: 0 }}>
            <SettingOutlined style={{ color: '#fa8c16', marginRight: '8px' }} />
            API Setting <span style={{ color: '#d9d9d9', margin: '0 8px' }}>/</span> {submenu_root}
          </Title>
          <Text type='secondary'>Manage external API configurations</Text>
        </div>
      </div>

      <Routes>
        <Route
          path='/sms'
          element={
            <APISettingSMS app_hostname={props.app_hostname} permitdata={props.permitdata} />
          }
        />
        <Route
          path='/email'
          element={
            <APISettingEmail app_hostname={props.app_hostname} permitdata={props.permitdata} />
          }
        />
        <Route
          path='/delivery'
          element={
            <APISettingDellivery app_hostname={props.app_hostname} permitdata={props.permitdata} />
          }
        />
        <Route path='*' element={<Navigate to='sms' replace />} />
      </Routes>
    </div>
  );
}

export default APISetting;
